module.exports = __webpack_public_path__ + "static/media/Twitter.e8344b34.svg";